import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../Redux';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
